<template>
  <div class="body">
    <div class="header">
      <a class="logo" href="javascript:;" @click="$router.push({path:'/'})">
        <img src="../assets/img/logo.svg" alt />
      </a>
      <a class="menu_btn" href="javascript:;" @click="$router.push('more')">
        <img src="../assets/img/menu.png" alt />
      </a>
    </div>
    <div class="box"></div>
    <div class="title-bj">
      <div class="title">{{model.title}}</div>
      <div class="priceBox">
        <span
          class="span"
        >会议时间：{{model.startTime.slice(0,model.startTime.length - 8)}} ~ {{model.endTime.slice(0,model.endTime.length - 8)}}</span>
        <span class="span">地点：{{model.region}}</span>
      </div>
    </div>
    <div class="sign">
      <div class="img">
        <img src="../assets/img/icon_Successz.png" alt="">
        <div v-if="model.data.isSession == 1">入场成功！</div>
        <div v-else>签到成功！<a @click="goSession" class="session">分论坛入场 >></a></div>
				
        <div v-if="model.data.isSession == 1">
					<span v-if="model.countSigned && model.countSigned > 0">欢迎回到“{{model.title}}”<span>{{model.sessionName}}</span>！</span>
					<span v-else>欢迎来到“{{model.title}}”<span>{{model.sessionName}}</span>！</span>
				</div>
        <div v-else>您已签到成功，请领取会议资料并入场！</div>
      </div>
      <div class="detail">
        <div class="item">
          <img src="../assets/img/icon_com.png" alt="">
          <span>企业名称：{{model.data.enName}}</span>
        </div>
        <div class="item">
          <img src="../assets/img/icon_per.png" alt="">
          <span>参会人：{{model.data.name}}</span>
        </div>
        <div class="item">
          <img src="../assets/img/icon_tel.png" alt="">
          <span>手机号码：{{model.data.phone}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      model:{
      	startTime: "",
      	endTime: "",
      	countSigned: 0
      },
    }
  },
  created () {
    this.content()
  },
  methods: {
    content () {
      this.$axios
        .post(`api/web/phone/content/detail/${this.$route.query.contentId}`, {})
        .then(res => {
          if (res.code == 200) {
            this.model = Object.assign(res.data, {
							data: JSON.parse(this.$route.query.data), 
							countSigned: 0,
						})
						
						// 分论坛 isSession = 1
						if (this.model.data.isSession && this.model.data.isSession == 1) {
							this.$axios
								.get(`api/web/phone/conference/sessionInfo?sessionId=${this.model.data.signSessionId}&attendeeId=${this.model.data.id}`, {})
								.then(res => {
									if (res.code == 200) {
										this.model.sessionName = res.data.sessionName
										this.model.countSigned = res.data.countSigned
									}
								})
						}
          }
        })
    },
		goSession() {
			this.$axios.post(`/api/web/phone/conference/resetSessionSign?attendeeId=${this.model.data.id}`).then(res => {})
			this.$router.push({
			  path: `/detail/signinCode`,
			  query: {
			    data: JSON.stringify(this.model.data),
			    contentId: this.$route.query.contentId,
					phoneNumber: this.model.data.phone,
					signStatus: 1,
			  }
			});
		}
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/sass/global.scss";
</style>
<style lang="scss" scoped>
.tip {
  font-size: 12px;
  color: #9f9f9f;
  margin: 20px 24px;
  text-align: left;
}
.priceBox {
  position: relative;
}
.TicketPrice {
  position: absolute;
  font-size: 12px;
  top: 0;
  right: 0;
}
.title-bj {
  padding: 26px;
  margin: 0 12px 0;
  min-height: 68px;
  background: url("../assets/img/dingdan_bg@3x.png");
  background-size: 100% 100%;
  position: relative;
}
.span {
  text-align: left;
  font-size: 12px;
  display: block;
  margin-top: 8px;
}
.title {
  text-align: left;
  font-weight: 700;
  font-size: 16px;
}
.sign {
  // height: 100% ;
  background: #fff;
  border-radius: 10px;
  z-index: -1;
  margin: -40px 40px 0;
  padding: 50px 12px 0;
  .detail {
    font-size: 14px;
    border-top: 1px dashed #c0c0c0;
    padding: 24px 0;
    margin: 24px 0;
    .item {
      text-align: left;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      img {
        width: 12px;
        height: 12px;
        padding-right: 10px;
      }
    }
    .trendbank {
      color: #9f9f9f;
      margin: 2px 0 24px;
      text-align: left;
    }
  }
  .img {
    margin-top: 10px;
    img {
      width: 25%;
      border-radius: 10px;
    }
    div:nth-child(2) {
      font-weight: bold;
      font-size: 14px;
      margin-top: 10px;
    }
    div:nth-child(3) {
      color: #9f9f9f;
      font-size: 12px;
      margin-top: 24px;
    }
		.session {
			color: #71c4f1;
			font-size: 12px;
			text-decoration: underline;
		}
  }
}

/* 使用webkit内核的浏览器 */
::-webkit-input-placeholder {
  color: #9f9f9f;
  line-height: normal;
  padding-top: 0.06rem;
}
/* Firefox版本4-18 */
:-moz-placeholder {
  color: #9f9f9f;
  padding-top: 0.06rem;
}
/* Firefox版本19+ */
::-moz-placeholder {
  color: #9f9f9f;
  padding-top: 0.06rem;
}
/* IE浏览器 */
:-ms-input-placeholder {
  color: #9f9f9f;
  padding-top: 0.06rem;
}
.p {
  margin: 9px 10px 0;
  font-size: 12px;
}
.box {
  height: 56px;
}
.body {
  position: fixed;
  width: 100%;
  height: 100%;
  // background-color: #fff;
}
.header {
  height: 54px;
  background: #ffffff;
  border-bottom: 2px solid #f5f5f5;
  top: 0;
  left: 0;
  right: 0;
  position: fixed;
  z-index: 99;
  .logo {
    display: inline-block;
    // width: 133px;
    // height: 38px;
    position: absolute;
    top: 10px;
    left: 15px;
    img{
      height: 35px;
    }
  }
  .menu_btn {
    display: inline-block;
    position: absolute;
    top: 13px;
    right: 13px;
    width: 29px;
    height: 29px;
    -webkit-tap-highlight-color: transparent;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/signinSuccess.vue